export const ORG_PROJECTS_TAGS = {
  ORG_PRE_SALES_PROJECTS: "OrgPreSalesProjects",
  ORG_POST_SALES_PROJECTS: "OrgPostSalesProjects",
  ORG_COMPLETED_PROJECTS: "OrgCompletedProjects",
} as const;
